import { Injectable } from '@angular/core';
import { HttpService, SmBaseService } from '../../core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class BulkActionService extends SmBaseService {
	constructor(
		http: HttpService,
	) {
		super(http, 'BulkAction');
	}

	getBulkActionInfo(actionGuid: string) {
		return this._getAs<IBulkActionInfoModel>(actionGuid);
	}

	executeBulkAction(actionCode: string, model: IBulkActionModel): Observable<IBulkActionResult> {
		return this._postAs<IBulkActionResult>(actionCode, model);
	}

	importFromOffer(model: IImportFromOfferModel): Observable<string> {
		return this.http.post(this.API_PREFIX + 'import/fromOffer', model).pipe(map(x => x.json() as string));
	}
}

export interface IImportFromOfferModel {
	importAllOffers: boolean;
	aukroOfferIds: number[];
}

export interface IBulkActionModel {
	targetIds: number[];
	input: any;
}

export interface IBulkActionResult {
	operationGuid: string;
	success: boolean;
	message: string;
}

export interface IBulkActionInfoModel {
	actionCode: string;
	actionName: string;
	aukroUsername: string;
	guid: string;
	id: number;
	startAt: Date;
	endAt?: Date;
	items: IBulkActionInfoItemModel[];
}

export interface IBulkActionInfoItemModel {
	targetId?: number;
	targetName: string;
	targetType: BulkActionTargetType;
	state: BulkActionState;
	stateName: string;
	description: string;
	aukroUsername: string;
}

export enum BulkActionState {
	Unknown,
	Done,
	Error
}

export enum BulkActionTargetType {
	Template,
	Offer,
	Transaction
}

/*

	executeBulkAction(actionCode: string, model: IBulkActionModel): Observable<IBulkActionResult> {
		if (actionCode == "import") {
			return this.http.post(`api/import/fromOffer`, model).map();
		}

		return this._postAs<IBulkActionResult>(`bulk/${actionCode}`, model);
	}

	getBulkActionInfo(actionGuid: string) {
		return this._getAs<IBulkActionInfoModel>(`bulk/${actionGuid}`);
	}
**/


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/bulk-action.service.ts